var map = {
	"./arrow_right.svg": 1086,
	"./bag.svg": 1088,
	"./caret_down.svg": 1089,
	"./chevron_down.svg": 1090,
	"./chevron_down_small.svg": 1091,
	"./chevron_left.svg": 1092,
	"./chevron_right.svg": 1093,
	"./chevron_up.svg": 1094,
	"./chevron_up_small.svg": 1095,
	"./close.svg": 1096,
	"./heart.svg": 1097,
	"./info-filled.svg": 1098,
	"./search-no-results.svg": 1099,
	"./search.svg": 1100,
	"./social-logo/apple.svg": 1101,
	"./social-logo/facebook.svg": 1102,
	"./social-logo/google.svg": 1103,
	"./stone-shape/asscher.svg": 1104,
	"./stone-shape/baguette.svg": 1105,
	"./stone-shape/cushion.svg": 1106,
	"./stone-shape/emerald.svg": 1107,
	"./stone-shape/heart.svg": 1108,
	"./stone-shape/marquise.svg": 1109,
	"./stone-shape/oval.svg": 1110,
	"./stone-shape/pear.svg": 1111,
	"./stone-shape/princess.svg": 1112,
	"./stone-shape/radiant.svg": 1113,
	"./stone-shape/round.svg": 1114,
	"./stone-shape/tapered-baguette.svg": 1115,
	"./stone-shape/triangle.svg": 1116,
	"./stone-shape/trillion.svg": 1117,
	"./user.svg": 1118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1085;